export type Maybe<T> = T | null
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string
  String: string
  Boolean: boolean
  Int: number
  Float: number
  FinnishDate: any
  LyytiBooleanKE: any
  LyytiDate: any
}

export type Address = {
  __typename?: 'Address'
  ensisijainen?: Maybe<Scalars['Boolean']>
  id?: Maybe<Scalars['Int']>
  katuosoite?: Maybe<Scalars['String']>
  maa?: Maybe<Scalars['String']>
  maaKoodi?: Maybe<Scalars['String']>
  paattymispvm?: Maybe<Scalars['FinnishDate']>
  poisto?: Maybe<Scalars['Int']>
  postinumero?: Maybe<Scalars['String']>
  postitoimipaikka?: Maybe<Scalars['String']>
  tyyppi?: Maybe<AddressType>
  virheellinen?: Maybe<Scalars['Boolean']>
  voimaantulopvm?: Maybe<Scalars['FinnishDate']>
}

export type AddressInput = {
  ensisijainen?: Maybe<Scalars['Boolean']>
  id?: Maybe<Scalars['Int']>
  katuosoite?: Maybe<Scalars['String']>
  maa?: Maybe<Scalars['String']>
  maaKoodi?: Maybe<Scalars['String']>
  paattymispvm?: Maybe<Scalars['FinnishDate']>
  paivittaja_ok?: Maybe<Scalars['Int']>
  poisto?: Maybe<Scalars['Int']>
  postinumero?: Maybe<Scalars['String']>
  postitoimipaikka?: Maybe<Scalars['String']>
  tyyppi: AddressType
  virheellinen?: Maybe<Scalars['Boolean']>
  voimaantulopvm?: Maybe<Scalars['FinnishDate']>
}

export enum AddressType {
  Kotiosoite = 'KOTIOSOITE',
  Muuosoite = 'MUUOSOITE',
  Tyoosoite = 'TYOOSOITE',
  ValiaikosLt = 'VALIAIKOS_LT'
}

export type Assignments = {
  __typename?: 'Assignments'
  jarjestotehtavat: Array<OrganizationalRole>
  luottamustehtavat: Array<StaffRepresentativeRole>
}

export type BankAccount = {
  __typename?: 'BankAccount'
  iban?: Maybe<Scalars['String']>
  konttori?: Maybe<Scalars['String']>
}

export type CommunicationsDataInput = {
  id?: Maybe<Scalars['Int']>
  kohde?: Maybe<Scalars['String']>
  kohdeKoodi?: Maybe<Scalars['Int']>
  kohdeKuvaus?: Maybe<Scalars['String']>
  kohde_en?: Maybe<Scalars['String']>
  kohde_sv?: Maybe<Scalars['String']>
  valinta?: Maybe<Scalars['Boolean']>
}

export type ContactInformationRelease = {
  __typename?: 'ContactInformationRelease'
  id?: Maybe<Scalars['Int']>
  kohde?: Maybe<Scalars['String']>
  kohdeKoodi?: Maybe<Scalars['Int']>
  kohdeKuvaus?: Maybe<Scalars['String']>
  kohde_en?: Maybe<Scalars['String']>
  kohde_sv?: Maybe<Scalars['String']>
  valinta?: Maybe<Scalars['Boolean']>
}

export type ContactInput = {
  osoitteet: Array<Maybe<AddressInput>>
  puhelinnumerot: Array<Maybe<PhoneInput>>
  sahkopostit: Array<Maybe<EmailInput>>
}

export type Contacts = {
  __typename?: 'Contacts'
  osoitteet?: Maybe<Array<Maybe<Address>>>
  puhelinnumerot?: Maybe<Array<Maybe<Phone>>>
  sahkopostit?: Maybe<Array<Maybe<Email>>>
}

export type Email = {
  __typename?: 'Email'
  ensisijainen?: Maybe<Scalars['Boolean']>
  id?: Maybe<Scalars['Int']>
  sahkopostiosoite?: Maybe<Scalars['String']>
  tyyppi?: Maybe<EmailType>
}

export type EmailInput = {
  ensisijainen: Scalars['Boolean']
  id?: Maybe<Scalars['Int']>
  paivittaja_ok?: Maybe<Scalars['Int']>
  poisto?: Maybe<Scalars['Int']>
  sahkopostiosoite: Scalars['String']
  tyyppi: EmailType
}

export enum EmailType {
  Email = 'EMAIL',
  EmailIlmo = 'EMAIL_ILMO'
}

export type Employment = {
  __typename?: 'Employment'
  alkupvm?: Maybe<Scalars['FinnishDate']>
  loppupvm?: Maybe<Scalars['FinnishDate']>
  paatoiminen?: Maybe<Scalars['LyytiBooleanKE']>
  taNimi?: Maybe<Scalars['String']>
  tpNimi?: Maybe<Scalars['String']>
  tunniste?: Maybe<Scalars['Int']>
  workPlaceOptions: Array<WorkPlace>
}

export type EmploymentInput = {
  alkupvm?: Maybe<Scalars['FinnishDate']>
  loppupvm?: Maybe<Scalars['FinnishDate']>
  paatoiminen?: Maybe<Scalars['LyytiBooleanKE']>
  taNimi?: Maybe<Scalars['String']>
  taPerinta?: Maybe<Scalars['LyytiBooleanKE']>
  tpNimi?: Maybe<Scalars['String']>
  tunniste?: Maybe<Scalars['Int']>
}

export type EmploymentObligations = {
  __typename?: 'EmploymentObligations'
  selfPaymentObligations: Array<SelfPaymentObligation>
  settlementObligations: Array<SettlementObligation>
}

export type EmploymentSummary = {
  __typename?: 'EmploymentSummary'
  alkupvm?: Maybe<Scalars['FinnishDate']>
  loppupvm?: Maybe<Scalars['FinnishDate']>
  taNimi?: Maybe<Scalars['String']>
}

export type EmploymentSummaryInfo = {
  __typename?: 'EmploymentSummaryInfo'
  tyosuhteet: Array<EmploymentSummary>
}

export type Employments = {
  __typename?: 'Employments'
  ammattiNimike?: Maybe<Scalars['String']>
  obligations: Array<EmploymentObligations>
  tyosuhteet: Array<Employment>
}

export type EmploymentsInput = {
  ammattiNimike?: Maybe<Scalars['String']>
  tyosuhteet: Array<EmploymentInput>
}

export type MemberMessage = {
  __typename?: 'MemberMessage'
  lahetysPvm?: Maybe<Scalars['String']>
  viestinNimi?: Maybe<Scalars['String']>
  viestinSisalto?: Maybe<Scalars['String']>
}

export type Membership = {
  __typename?: 'Membership'
  ammattiosasto?: Maybe<Scalars['String']>
  ammattiosastoTunnus?: Maybe<Scalars['String']>
  jasenlaji?: Maybe<Scalars['String']>
  liittymispvm?: Maybe<Scalars['String']>
}

export type MembershipCard = {
  __typename?: 'MembershipCard'
  jasenkortin_nimi?: Maybe<Scalars['String']>
  jasenkortin_toimituspvm?: Maybe<Scalars['String']>
  jasenkortin_tyyppi?: Maybe<Scalars['String']>
  jasenkortin_tyyppi_nimi?: Maybe<Scalars['String']>
  jasenkortti?: Maybe<Scalars['String']>
  kortin_tilaus?: Maybe<Scalars['Boolean']>
}

export type MembershipCardInput = {
  jasenkortin_nimi?: Maybe<Scalars['String']>
  jasenkortin_toimituspvm?: Maybe<Scalars['String']>
  jasenkortin_tyyppi?: Maybe<Scalars['String']>
  jasenkortin_tyyppi_nimi?: Maybe<Scalars['String']>
  jasenkortti?: Maybe<Scalars['String']>
  kortin_tilaus?: Maybe<Scalars['Boolean']>
}

export type MembershipFeeAccrualBases = {
  __typename?: 'MembershipFeeAccrualBases'
  maksujaksonAlkupvm?: Maybe<Scalars['FinnishDate']>
  maksujaksonLoppupvm?: Maybe<Scalars['FinnishDate']>
  prosentti?: Maybe<Scalars['Float']>
  summa?: Maybe<Scalars['Float']>
  summaMaksukatto?: Maybe<Scalars['Float']>
  tyyppi?: Maybe<Scalars['String']>
}

export type MembershipFeeObligations = {
  __typename?: 'MembershipFeeObligations'
  paymentExemptions?: Maybe<Array<Maybe<PaymentExemption>>>
  selfPaymentObligations?: Maybe<Array<Maybe<SelfPaymentObligation>>>
  settlementObligations?: Maybe<Array<Maybe<SettlementObligation>>>
}

export type MembershipInfo = {
  __typename?: 'MembershipInfo'
  jasennumero?: Maybe<Scalars['String']>
  jasenyys?: Maybe<Membership>
}

export type MembershipMagazine = {
  __typename?: 'MembershipMagazine'
  alkupvm?: Maybe<Scalars['String']>
  lehti?: Maybe<Scalars['String']>
  loppupvm?: Maybe<Scalars['String']>
}

export type MembershipMagazines = {
  __typename?: 'MembershipMagazines'
  lehdet?: Maybe<Array<Maybe<MembershipMagazine>>>
}

export type MembershipSummary = {
  __typename?: 'MembershipSummary'
  ammattiosasto?: Maybe<Scalars['String']>
  ammattiosastoTunnus?: Maybe<Scalars['String']>
}

export type MembershipSummaryInfo = {
  __typename?: 'MembershipSummaryInfo'
  jasennumero?: Maybe<Scalars['Int']>
  jasenyys?: Maybe<MembershipSummary>
}

export type Mutation = {
  __typename?: 'Mutation'
  saveCommunicationsData?: Maybe<Scalars['String']>
  saveEmploymentsData?: Maybe<Array<Maybe<Scalars['String']>>>
  saveMembershipCard: Scalars['String']
  savePaymentExemption: Scalars['String']
  saveUserInfo: Scalars['String']
}

export type MutationSaveCommunicationsDataArgs = {
  communicationsData: Array<Maybe<CommunicationsDataInput>>
}

export type MutationSaveEmploymentsDataArgs = {
  employmentsData?: Maybe<EmploymentsInput>
}

export type MutationSaveMembershipCardArgs = {
  membershipCard?: Maybe<MembershipCardInput>
}

export type MutationSavePaymentExemptionArgs = {
  paymentExemption?: Maybe<PaymentExemptionInput>
}

export type MutationSaveUserInfoArgs = {
  userInfo?: Maybe<UserInput>
}

export type Name = {
  __typename?: 'Name'
  etunimet?: Maybe<Scalars['String']>
  kutsumanimi?: Maybe<Scalars['String']>
  sukunimi?: Maybe<Scalars['String']>
}

export type NameInput = {
  etunimet?: Maybe<Scalars['String']>
  kutsumanimi?: Maybe<Scalars['String']>
  sukunimi?: Maybe<Scalars['String']>
}

export type Nationality = {
  __typename?: 'Nationality'
  kansalaisuus?: Maybe<Scalars['String']>
  kansalaisuusKoodi?: Maybe<Scalars['String']>
}

export type NationalityInput = {
  kansalaisuus?: Maybe<Scalars['String']>
  kansalaisuusKoodi?: Maybe<Scalars['String']>
}

export type NativeLanguage = {
  __typename?: 'NativeLanguage'
  aidinkieli?: Maybe<Scalars['String']>
  aidinkieliKoodi?: Maybe<Scalars['String']>
}

export type NativeLanguageInput = {
  aidinkieli?: Maybe<Scalars['String']>
  aidinkieliKoodi?: Maybe<Scalars['String']>
}

export type NewsDataRow = {
  __typename?: 'NewsDataRow'
  id: Scalars['String']
  translations: Array<NewsTranslation>
  type: Scalars['String']
}

export type NewsTranslation = {
  __typename?: 'NewsTranslation'
  content: Scalars['String']
  endDate: Scalars['String']
  header: Scalars['String']
  lang: Scalars['String']
  startDate: Scalars['String']
}

export type OrganizationalRole = {
  __typename?: 'OrganizationalRole'
  aloituspvm?: Maybe<Scalars['FinnishDate']>
  jarjestoyksikonNimi?: Maybe<Scalars['String']>
  kaudenLopetuspvm?: Maybe<Scalars['FinnishDate']>
  lopetuspvm?: Maybe<Scalars['FinnishDate']>
  tehtava?: Maybe<Scalars['String']>
}

export type PaidMembershipFee = {
  __typename?: 'PaidMembershipFee'
  maksajanMaksupvm?: Maybe<Scalars['LyytiDate']>
  maksajanNimi?: Maybe<Scalars['String']>
  maksajanTyonantajantunnus?: Maybe<Scalars['String']>
  maksujaksoAlkupvm?: Maybe<Scalars['LyytiDate']>
  maksujaksoLoppupvm?: Maybe<Scalars['LyytiDate']>
  peruttu?: Maybe<Scalars['Boolean']>
  summa?: Maybe<Scalars['Float']>
  tapahtumatyyppi?: Maybe<Scalars['String']>
  tositenumero?: Maybe<Scalars['Int']>
  varojenjakoTehty?: Maybe<Scalars['String']>
  verovuosi?: Maybe<Scalars['String']>
  viitenumero?: Maybe<Scalars['String']>
}

export type PaymentExemption = {
  __typename?: 'PaymentExemption'
  aloituspvm?: Maybe<Scalars['FinnishDate']>
  lopetuspvm?: Maybe<Scalars['FinnishDate']>
  tunniste?: Maybe<Scalars['Int']>
  vapautuslaji?: Maybe<Scalars['String']>
  vapautuslajiKoodi?: Maybe<Scalars['String']>
  vapautussyy?: Maybe<Scalars['String']>
  vapautussyyKoodi?: Maybe<Scalars['String']>
}

export type PaymentExemptionInput = {
  alkupvm?: Maybe<Scalars['FinnishDate']>
  loppupvm?: Maybe<Scalars['FinnishDate']>
  syykoodi?: Maybe<Scalars['String']>
}

export type Phone = {
  __typename?: 'Phone'
  ensisijainen?: Maybe<Scalars['Boolean']>
  id?: Maybe<Scalars['Int']>
  poisto?: Maybe<Scalars['Int']>
  puhelinnumero?: Maybe<Scalars['String']>
  tyyppi?: Maybe<PhoneType>
}

export type PhoneInput = {
  ensisijainen: Scalars['Boolean']
  id?: Maybe<Scalars['Int']>
  paivittaja_ok?: Maybe<Scalars['Int']>
  poisto?: Maybe<Scalars['Int']>
  puhelinnumero: Scalars['String']
  tyyppi: PhoneType
}

export enum PhoneType {
  Fax = 'FAX',
  Gsm = 'GSM',
  Kotipuhelin = 'KOTIPUHELIN',
  Tyopuhelin = 'TYOPUHELIN'
}

export type Query = {
  __typename?: 'Query'
  accrualBasesLastYear: Array<MembershipFeeAccrualBases>
  accrualBasesThisYear: Array<MembershipFeeAccrualBases>
  assignments: Assignments
  bankAccounts: Array<BankAccount>
  businessLanguages: Translations
  countries: Translations
  emailTypes: Translations
  employmentObligations?: Maybe<EmploymentObligations>
  employmentSummaryInfo?: Maybe<EmploymentSummaryInfo>
  employments?: Maybe<Employments>
  exemptionReasons: Translations
  languages: Translations
  memberEmailsAndSms: Array<MemberMessage>
  memberLetters: Array<MemberMessage>
  membershipCard?: Maybe<MembershipCard>
  membershipCardTypes: Translations
  membershipFeeObligations?: Maybe<MembershipFeeObligations>
  membershipInfo?: Maybe<MembershipInfo>
  membershipMagazines?: Maybe<MembershipMagazines>
  membershipSummaryInfo?: Maybe<MembershipSummaryInfo>
  news: Array<NewsDataRow>
  paidMembershipFees?: Maybe<Array<Maybe<PaidMembershipFee>>>
  postalCodes: Translations
  refenceNumbers?: Maybe<Array<Maybe<RefenceNumber>>>
  userInfo?: Maybe<UserInfo>
  versionInfo: VersionInfo
}

export type RefenceNumber = {
  __typename?: 'RefenceNumber'
  alkupvm?: Maybe<Scalars['LyytiDate']>
  erapaiva?: Maybe<Scalars['LyytiDate']>
  loppupvm?: Maybe<Scalars['LyytiDate']>
  pankkiviivakoodi?: Maybe<Scalars['String']>
  viitenumero?: Maybe<Scalars['String']>
}

export type SelfPaymentObligation = {
  __typename?: 'SelfPaymentObligation'
  aloituspvm: Scalars['FinnishDate']
  elaskuSumma?: Maybe<Scalars['Float']>
  lopetuspvm?: Maybe<Scalars['FinnishDate']>
  maksujaksonPituus?: Maybe<Scalars['Int']>
  maksurytmi?: Maybe<Scalars['String']>
  tunniste?: Maybe<Scalars['Int']>
  viitelaji: Scalars['String']
  viitelajiKoodi?: Maybe<Scalars['String']>
  viitetulostus?: Maybe<Scalars['Int']>
}

export type SettlementObligation = {
  __typename?: 'SettlementObligation'
  aloituspvm?: Maybe<Scalars['FinnishDate']>
  lopetuspvm?: Maybe<Scalars['FinnishDate']>
  selvittajanNimi?: Maybe<Scalars['String']>
  selvittajanTyonantajatunnus?: Maybe<Scalars['String']>
  tilittajanNimi?: Maybe<Scalars['String']>
  tilittajanTyonantajatunnus?: Maybe<Scalars['String']>
  tilitystapa?: Maybe<Scalars['String']>
  tilitystapaKoodi?: Maybe<Scalars['String']>
  tunniste?: Maybe<Scalars['Int']>
  viitetulostus?: Maybe<Scalars['Int']>
}

export type StaffRepresentativeRole = {
  __typename?: 'StaffRepresentativeRole'
  aloituspvm?: Maybe<Scalars['FinnishDate']>
  kaudenLopetuspvm?: Maybe<Scalars['FinnishDate']>
  lopetuspvm?: Maybe<Scalars['FinnishDate']>
  taNimi?: Maybe<Scalars['String']>
  tehtava?: Maybe<Scalars['String']>
  tpNimi?: Maybe<Scalars['String']>
}

export type Translation = {
  __typename?: 'Translation'
  display?: Maybe<Scalars['String']>
  value?: Maybe<Scalars['String']>
}

export type Translations = {
  __typename?: 'Translations'
  en: Array<Translation>
  fi: Array<Translation>
  sv: Array<Translation>
}

export type UserInfo = {
  __typename?: 'UserInfo'
  aidinkieli?: Maybe<NativeLanguage>
  asiointikieli?: Maybe<Scalars['String']>
  jasennumero?: Maybe<Scalars['Int']>
  kansalaisuus?: Maybe<Nationality>
  luvat?: Maybe<Array<Maybe<ContactInformationRelease>>>
  nimi?: Maybe<Name>
  viimeisinKirjautuminen?: Maybe<Scalars['LyytiDate']>
  yhteystiedot?: Maybe<Contacts>
}

export type UserInput = {
  aidinkieli?: Maybe<NativeLanguageInput>
  asiointikieli?: Maybe<Scalars['String']>
  kansalaisuus?: Maybe<NationalityInput>
  nimi?: Maybe<NameInput>
  viimeisinKirjautuminen?: Maybe<Scalars['LyytiDate']>
  yhteystiedot?: Maybe<ContactInput>
}

export type VersionInfo = {
  __typename?: 'VersionInfo'
  version: Scalars['String']
}

export type WorkPlace = {
  __typename?: 'WorkPlace'
  display: Scalars['String']
  value: Scalars['String']
}
